/*
 * NSE Machine Library (2026-10-29): LaserIQ-style machine search on this store's products.
 * Data: inline JSON from sections/nse-machine-library.liquid (+ /collections/all?view=library-json&page=N
 * when there are more than 250 products). Quote-only machines carry no price in the data.
 * URL params (deep links from the menu): q, brand, category, laser, fmt (format; Shopify reserves ?format=), buy, power, sort, dir, per, p, compare
 */
(function () {
  var root = document.querySelector('.nse-ml');
  if (!root) return;
  var dataEl = root.querySelector('[data-ml-data]');
  var ALL = [];
  try { ALL = JSON.parse(dataEl.textContent); } catch (e) { ALL = []; }
  var NOCAT = 'Accessories & software';

  var $ = function (s) { return root.querySelector(s); };
  var els = {
    q: $('[data-ml="q"]'), brand: $('[data-ml="brand"]'), category: $('[data-ml="category"]'), laser: $('[data-ml="laser"]'),
    format: $('[data-ml="format"]'), buy: $('[data-ml="buy"]'), power: $('[data-ml="power"]'), per: $('[data-ml="per"]'),
    rows: $('[data-ml-rows]'), count: $('[data-ml-count]'), note: $('[data-ml-note]'), empty: $('[data-ml-empty]'), pager: $('[data-ml-pager]')
  };
  var FACETS = {
    brand: function (m) { return m.b ? [m.b] : []; },
    category: function (m) { return m.c && m.c.length ? m.c : [NOCAT]; },
    laser: function (m) { return m.l ? [m.l] : []; },
    format: function (m) { return m.f ? [m.f] : []; },
    buy: function (m) { return [m.q ? 'Request a quote' : (m.buy || 'Buy online')]; }
  };
  var state = { q: '', brand: '', category: '', laser: '', format: '', buy: '', power: '', sort: '', dir: 'asc', per: parseInt(root.getAttribute('data-per-page'), 10) || 25, p: 1 };

  function slug(s) { return String(s || '').toLowerCase().replace(/['’]/g, '').replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function esc(s) { return window.NSECompare ? NSECompare.esc(s) : String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function fmtPower(w) {
    w = Number(w); if (!w) return '';
    return w >= 1000 ? (Math.round(w / 100) / 10).toString().replace(/\.0$/, '') + ' kW' : Math.round(w) + ' W';
  }

  /* ---------- search index ---------- */
  var SYN = {
    'Welding': 'welding welder welders weld welds',
    'Cutting': 'cutting cutter cutters cut',
    'Cleaning': 'cleaning cleaner cleaners clean rust removal',
    'Bending': 'bending bender press brake brakes pressbrake',
    'Engraving & marking': 'engraving engraver engravers marking marker markers engrave mark',
    'Printing & heat press': 'printing printer printers heat press apparel',
    'Automation & robotics': 'automation automated robot robots robotic robotics cobot',
    'Laser sources': 'laser source sources resonator',
    'Tube': 'tube tubes pipe pipes profile',
    'Sheet + tube': 'tube tubes sheet',
    'Handheld': 'handheld portable',
    'Desktop': 'desktop'
  };
  var PW_RE = /(\d+(?:[.,]\d+)?)\s*(kw|w)(?![a-z])/gi;
  function powerTokens(str, out) {
    var m; PW_RE.lastIndex = 0;
    while ((m = PW_RE.exec(str))) {
      var v = parseFloat(m[1].replace(',', '.'));
      var w = m[2].toLowerCase() === 'kw' ? v * 1000 : v;
      if (w > 0) out[(Math.round(w / 100) / 10) + 'kw'] = 1;
    }
    return out;
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9.+]+/g, ' ').trim(); }
  ALL.forEach(prep);
  function prep(m) {
    var cats = FACETS.category(m);
    var syn = cats.map(function (c) { return SYN[c] || ''; }).join(' ') + ' ' + (SYN[m.f] || '');
    m._t = norm(m.t); m._b = norm(m.b) + ' ' + slug(m.b).replace(/-/g, '');
    m._o = norm([cats.join(' '), syn, m.l, m.f, m.ty, (m.a || []).join(' ')].join(' '));
    m._words = (m._t + ' ' + m._b + ' ' + m._o).split(/\s+/);
    var pt = {};
    if (m.w) pt[(Math.round(Number(m.w) / 100) / 10) + 'kw'] = 1;
    powerTokens(m.t + ' ' + (m.pv || ''), pt);
    m._pw = pt;
  }
  var STOP = { the: 1, a: 1, an: 1, and: 1, or: 1, for: 1, with: 1, of: 1, to: 1, in: 1, machine: 1, machines: 1 };
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      var cur = [i], best = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }
  function parseQuery(q) {
    var pt = {}; powerTokens(q, pt);
    var rest = norm(q.replace(PW_RE, ' '));
    var words = rest ? rest.split(/\s+/).filter(function (w) { return w && !STOP[w]; }) : [];
    return { pw: Object.keys(pt), words: words };
  }
  function stem(w) { return w.length > 4 ? w.replace(/(es|s)$/, '') : w; }
  // returns {score, hits, fuzzy} for one machine
  function scoreItem(m, pq) {
    var score = 0, hits = 0, fuzzy = false, need = pq.words.length + pq.pw.length;
    pq.pw.forEach(function (t) { if (m._pw[t]) { hits++; score += 3; } });
    pq.words.forEach(function (w) {
      var s = stem(w);
      if (m._t.indexOf(w) > -1 || m._t.indexOf(s) > -1) { hits++; score += 3; return; }
      if (m._b.indexOf(w) > -1 || m._b.indexOf(s) > -1) { hits++; score += 2; return; }
      if (m._o.indexOf(w) > -1 || m._o.indexOf(s) > -1) { hits++; score += 1; return; }
      if (w.length >= 4) {
        var max = w.length >= 8 ? 2 : 1;
        for (var i = 0; i < m._words.length; i++) {
          var x = m._words[i];
          if (x.length >= 3 && lev(w, x, max) <= max) { hits++; score += 0.5; fuzzy = true; return; }
        }
      }
    });
    return { score: score, hits: hits, all: hits === need, fuzzy: fuzzy };
  }

  /* ---------- filtering ---------- */
  function matchFacet(m, key, val) {
    if (!val) return true;
    var vs = FACETS[key](m), sv = slug(val);
    for (var i = 0; i < vs.length; i++) if (vs[i] === val || slug(vs[i]) === sv) return true;
    return false;
  }
  function passFilters(m, skip) {
    for (var k in FACETS) { if (k !== skip && !matchFacet(m, k, state[k])) return false; }
    var pw = parseFloat(state.power);
    if (skip !== 'power' && pw > 0 && !(Number(m.w) >= pw)) return false;
    return true;
  }
  var searchCache = { key: null, res: null };
  function searchResults() {
    var q = state.q.trim();
    if (!q) return { list: ALL.map(function (m) { return { m: m, s: 0 }; }), loose: false };
    if (searchCache.key === q + '|' + ALL.length) return searchCache.res;
    var pq = parseQuery(q), strict = [], loose = [];
    if (!pq.words.length && !pq.pw.length) return { list: ALL.map(function (m) { return { m: m, s: 0 }; }), loose: false };
    ALL.forEach(function (m) {
      var r = scoreItem(m, pq);
      if (r.all) strict.push({ m: m, s: r.score, f: r.fuzzy });
      else if (r.hits > 0) loose.push({ m: m, s: r.score, f: true });
    });
    var res = strict.length ? { list: strict, loose: false } : { list: loose, loose: loose.length > 0 };
    res.list.sort(function (a, b) { return b.s - a.s; });
    searchCache = { key: q + '|' + ALL.length, res: res };
    return res;
  }

  /* ---------- facets with live counts ---------- */
  var LABEL = { brand: 'All brands', category: 'All categories', laser: 'Any laser source', format: 'Any format', buy: 'Any' };
  function buildFacets(base) {
    Object.keys(FACETS).forEach(function (k) {
      var counts = {};
      base.forEach(function (r) { if (passFilters(r.m, k)) FACETS[k](r.m).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; }); });
      var allVals = {};
      ALL.forEach(function (m) { FACETS[k](m).forEach(function (v) { allVals[v] = 1; }); });
      var vals = Object.keys(allVals).sort(function (a, b) { if (a === NOCAT) return 1; if (b === NOCAT) return -1; return a.localeCompare(b); });
      var cur = state[k], curReal = '';
      vals.forEach(function (v) { if (cur && (v === cur || slug(v) === slug(cur))) curReal = v; });
      var html = '<option value="">' + LABEL[k] + '</option>';
      vals.forEach(function (v) {
        var n = counts[v] || 0;
        if (!n && v !== curReal) return;
        html += '<option value="' + esc(v) + '"' + (v === curReal ? ' selected' : '') + '>' + esc(v) + ' (' + n + ')</option>';
      });
      els[k].innerHTML = html;
      if (curReal) state[k] = curReal;
    });
  }

  /* ---------- sorting ---------- */
  function sortVal(m, key) {
    if (key === 'b') return (m.b || '').toLowerCase();
    if (key === 't') return (m.t || '').toLowerCase();
    if (key === 'c') return (m.c && m.c.length ? m.c.join(', ') : '').toLowerCase();
    if (key === 'w') return m.w ? Number(m.w) : null;
    return '';
  }
  function applySort(list) {
    var key = state.sort, dir = state.dir === 'desc' ? -1 : 1;
    if (!key) {
      if (state.q.trim()) return list; // relevance order
      key = 'b'; dir = 1;
      return list.sort(function (a, b) { var x = sortVal(a.m, 'b'), y = sortVal(b.m, 'b'); return x < y ? -1 : x > y ? 1 : sortVal(a.m, 't') < sortVal(b.m, 't') ? -1 : 1; });
    }
    return list.sort(function (a, b) {
      var x = sortVal(a.m, key), y = sortVal(b.m, key);
      var bx = x === null || x === '', by = y === null || y === '';
      if (bx && by) return 0; if (bx) return 1; if (by) return -1; // blanks always last
      if (x < y) return -dir; if (x > y) return dir;
      return sortVal(a.m, 't') < sortVal(b.m, 't') ? -1 : 1;
    });
  }

  /* ---------- render ---------- */
  function rowHtml(m, fuzzy) {
    var cats = m.c && m.c.length ? m.c.join(', ') : NOCAT;
    var area = (m.a || []).join(', ');
    var pw = fmtPower(m.w);
    var checked = window.NSECompare && NSECompare.has(m.id) ? ' checked' : '';
    var price = m.q || !m.p
      ? '<a class="nse-ml__quote" href="' + esc(m.u) + '#request-quote">Request a quote</a>'
      : '<span class="nse-ml__price">' + esc(m.p) + '</span>';
    var meta = [cats, pw, area].filter(Boolean).join(' · ');
    return '<tr data-id="' + m.id + '">' +
      '<td class="nse-ml__cmp"><label title="Compare"><input type="checkbox" class="nse-cmp-cb" data-id="' + m.id + '"' + checked + ' aria-label="Compare ' + esc(m.t) + '"></label></td>' +
      '<td class="nse-ml__img"><a href="' + esc(m.u) + '" tabindex="-1" aria-hidden="true">' + (m.i ? '<img class="nse-ml__thumb" src="' + esc(m.i) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="nse-ml__thumb nse-ml__thumb--ph"></span>') + '</a></td>' +
      '<td class="nse-ml__brand">' + esc(m.b) + '</td>' +
      '<td class="nse-ml__model"><a href="' + esc(m.u) + '">' + esc(m.t) + '</a>' + (fuzzy ? '<span class="nse-ml__fuzzy">close match</span>' : '') + '</td>' +
      '<td class="nse-ml__cat">' + esc(cats) + '</td>' +
      '<td class="nse-ml__pw">' + (pw ? esc(pw) : '<span class="nse-ml__muted">–</span>') + '</td>' +
      '<td class="nse-ml__area">' + (area ? esc(area) : '<span class="nse-ml__muted">–</span>') + '</td>' +
      '<td class="nse-ml__meta">' + esc(meta) + '</td>' +
      '<td class="nse-ml__pricecell">' + price + '</td>' +
      '</tr>';
  }
  var BY_ID = {};
  function render(push) {
    var sr = searchResults();
    buildFacets(sr.list);
    var list = sr.list.filter(function (r) { return passFilters(r.m); });
    list = applySort(list.slice());
    var total = list.length, per = state.per, pages = Math.max(1, Math.ceil(total / per));
    if (state.p > pages) state.p = pages;
    if (state.p < 1) state.p = 1;
    var start = (state.p - 1) * per, slice = list.slice(start, start + per);
    els.rows.innerHTML = slice.map(function (r) { return rowHtml(r.m, sr.loose || r.f); }).join('');
    els.rows.querySelectorAll('input.nse-cmp-cb').forEach(function (cb) { cb._nseMachine = BY_ID[cb.getAttribute('data-id')]; });
    els.count.textContent = total ? total.toLocaleString() + ' of ' + ALL.length.toLocaleString() + ' machines · ' + (start + 1) + '–' + (start + slice.length) : '0 of ' + ALL.length.toLocaleString() + ' machines';
    els.empty.hidden = total > 0;
    els.note.hidden = !sr.loose;
    els.note.textContent = sr.loose ? 'No exact match for “' + state.q.trim() + '”. Showing close matches.' : '';
    els.q.value = state.q; els.power.value = state.power; els.per.value = String(state.per);
    root.querySelectorAll('th[aria-sort]').forEach(function (th) {
      var b = th.querySelector('[data-sort]');
      th.setAttribute('aria-sort', b && b.getAttribute('data-sort') === state.sort ? (state.dir === 'desc' ? 'descending' : 'ascending') : 'none');
    });
    renderPager(pages);
    syncUrl(push);
  }
  function renderPager(pages) {
    var p = state.p, h = '';
    function btn(label, page, opts) {
      opts = opts || {};
      return '<button type="button" data-page="' + page + '"' + (opts.dis ? ' disabled' : '') + (opts.cur ? ' aria-current="page"' : '') + (opts.aria ? ' aria-label="' + opts.aria + '"' : '') + '>' + label + '</button>';
    }
    h += btn('First', 1, { dis: p === 1, aria: 'First page' }) + btn('Prev', p - 1, { dis: p === 1, aria: 'Previous page' });
    var from = Math.max(1, p - 2), to = Math.min(pages, p + 2);
    if (from > 1) { h += btn('1', 1); if (from > 2) h += '<span class="nse-ml__gap">…</span>'; }
    for (var i = from; i <= to; i++) h += btn(String(i), i, { cur: i === p, aria: 'Page ' + i });
    if (to < pages) { if (to < pages - 1) h += '<span class="nse-ml__gap">…</span>'; h += btn(String(pages), pages); }
    h += btn('Next', p + 1, { dis: p === pages, aria: 'Next page' }) + btn('Last', pages, { dis: p === pages, aria: 'Last page' });
    els.pager.innerHTML = h;
  }

  /* ---------- URL state ---------- */
  var KEYS = ['q', 'brand', 'category', 'laser', 'format', 'buy', 'power', 'sort', 'dir', 'per', 'p'];
  var PARAM = { format: 'fmt' }; // Shopify reserves ?format= (returns 404), so the format filter uses ?fmt=
  function readUrl() {
    var sp = new URLSearchParams(location.search);
    KEYS.forEach(function (k) {
      var pk = PARAM[k] || k;
      if (!sp.has(pk)) return;
      var v = sp.get(pk);
      if (k === 'per') { var n = parseInt(v, 10); if ([25, 50, 100, 200].indexOf(n) > -1) state.per = n; }
      else if (k === 'p') state.p = parseInt(v, 10) || 1;
      else if (k === 'type') state.category = v;
      else state[k] = v;
    });
    if (sp.has('type') && !sp.has('category')) state.category = sp.get('type');
    if (sp.has('vendor') && !sp.has('brand')) state.brand = sp.get('vendor');
  }
  function syncUrl(push) {
    var sp = new URLSearchParams(location.search);
    KEYS.forEach(function (k) { sp.delete(PARAM[k] || k); });
    ['type', 'vendor'].forEach(function (k) { sp.delete(k); });
    if (state.q.trim()) sp.set('q', state.q.trim());
    ['brand', 'category', 'laser', 'format', 'buy'].forEach(function (k) { if (state[k]) sp.set(PARAM[k] || k, slug(state[k])); });
    if (parseFloat(state.power) > 0) sp.set('power', String(parseFloat(state.power)));
    if (state.sort) { sp.set('sort', state.sort); sp.set('dir', state.dir); }
    if (state.per !== (parseInt(root.getAttribute('data-per-page'), 10) || 25)) sp.set('per', state.per);
    if (state.p > 1) sp.set('p', state.p);
    var qs = sp.toString(), url = location.pathname + (qs ? '?' + qs : '') + location.hash;
    if (url !== location.pathname + location.search + location.hash) history[push ? 'pushState' : 'replaceState'](null, '', url);
  }

  /* ---------- events ---------- */
  var tq;
  els.q.addEventListener('input', function () { clearTimeout(tq); tq = setTimeout(function () { state.q = els.q.value; state.p = 1; state.sort = state.sort; render(); }, 150); });
  ['brand', 'category', 'laser', 'format', 'buy'].forEach(function (k) {
    els[k].addEventListener('change', function () { state[k] = els[k].value; state.p = 1; render(); });
  });
  els.power.addEventListener('input', function () { clearTimeout(tq); tq = setTimeout(function () { state.power = els.power.value; state.p = 1; render(); }, 250); });
  els.per.addEventListener('change', function () { state.per = parseInt(els.per.value, 10) || 25; state.p = 1; render(); });
  root.addEventListener('click', function (e) {
    var r = e.target.closest('[data-ml-reset]');
    if (r) { ['q', 'brand', 'category', 'laser', 'format', 'buy', 'power', 'sort'].forEach(function (k) { state[k] = ''; }); state.dir = 'asc'; state.p = 1; render(true); return; }
    var s = e.target.closest('[data-sort]');
    if (s) { var k = s.getAttribute('data-sort'); if (state.sort === k) state.dir = state.dir === 'asc' ? 'desc' : 'asc'; else { state.sort = k; state.dir = 'asc'; } state.p = 1; render(); return; }
    var pg = e.target.closest('[data-page]');
    if (pg && !pg.disabled) { state.p = parseInt(pg.getAttribute('data-page'), 10) || 1; render(true); root.querySelector('.nse-ml__bar').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  window.addEventListener('popstate', function () { state = Object.assign(state, { q: '', brand: '', category: '', laser: '', format: '', buy: '', power: '', sort: '', dir: 'asc', p: 1 }); readUrl(); render(); });

  /* ---------- load + extra pages ---------- */
  function indexAll() { BY_ID = {}; ALL.forEach(function (m) { BY_ID[String(m.id)] = m; }); }
  function afterLoad() {
    indexAll();
    if (window.NSECompare) {
      NSECompare.refresh(ALL);
      var sp = new URLSearchParams(location.search);
      if (sp.get('compare')) {
        var hs = sp.get('compare').split(',').slice(0, 4), byH = {};
        ALL.forEach(function (m) { byH[m.h] = m; });
        var picks = hs.map(function (h) { return byH[h]; }).filter(Boolean);
        if (picks.length) { NSECompare.clear(); picks.forEach(function (m) { NSECompare.add(m); }); NSECompare.open(); }
      }
    }
  }
  readUrl();
  indexAll();
  render();
  var pages = parseInt(dataEl.getAttribute('data-pages'), 10) || 1, cur = parseInt(dataEl.getAttribute('data-page'), 10) || 1;
  if (pages > 1) {
    var jobs = [];
    for (var i = 1; i <= pages; i++) if (i !== cur) jobs.push(fetch('/collections/all?view=library-json&page=' + i, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t).items || []; }).catch(function () { return []; }));
    Promise.all(jobs).then(function (lists) {
      var seen = {}; ALL.forEach(function (m) { seen[m.id] = 1; });
      lists.forEach(function (l) { l.forEach(function (m) { if (!seen[m.id]) { seen[m.id] = 1; prep(m); ALL.push(m); } }); });
      searchCache.key = null; render(); afterLoad();
    });
  } else {
    afterLoad();
  }
})();
